import * as actionTypes from '../actions/actionTypes';
import {updateObject} from '../utilities';
import basemap_google_satellite from '../../assets/images/basemap_google_satellite.png'
import basemap_google_roadmap from '../../assets/images/basemap_google_roadmap.png'
import basemap_google_terrain from '../../assets/images/basemap_google_terrain.png'
import basemap_openstreetmap from '../../assets/images/basemap_openstreetmap.png'
import basemap_cardo_db from '../../assets/images/basemap_cardo_db.png'
import basemap_esri_world from '../../assets/images/basemap_esri_world.png'

const initialState = {
    mapBounds:[[34.5, 17.13],[41.80,30.68]],
    basemapLayers:[
        {
            name:'satellite',
            label:'Google Satellite',
            maxZoom: 20,
            isGoogle: true,
            key:'AIzaSyB7wxoH28aEIcYKWxUt7vmGrJ_zFKdZosU',
            image:basemap_google_satellite
        },
        {
            name:'roadmap',
            label:'Google Roadmap',
            maxZoom: 20,
            isGoogle: true,
            key:'AIzaSyB7wxoH28aEIcYKWxUt7vmGrJ_zFKdZosU',
            image:basemap_google_roadmap
        },
        {
            name:'terrain',
            label:'Google Terrain',
            maxZoom: 20,
            isGoogle: true,
            key:'AIzaSyB7wxoH28aEIcYKWxUt7vmGrJ_zFKdZosU',
            image:basemap_google_terrain
        },
        {
            name:'OpenStreetMap_Mapnik',
            label:'Open Street Map',
            url:'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
            // attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
            attribution: '',
            maxZoom: 19,
            isGoogle: false,
            image:basemap_openstreetmap
        },
        {
            name:'CartoDB_Positron',
            label:'CartoDB Positron',
            url:'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png',
            // attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
            attribution: '',
            subdomains: 'abcd',
            maxZoom: 19,
            isGoogle: false,
            image:basemap_cardo_db
        },
        {
            name:'Esri_WorldImagery',
            label:'Esri World Imagery',
            url:'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
            // attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
            attribution: '',
            maxZoom: 15,
            isGoogle: false,
            image:basemap_esri_world
        },
    ],
    selectedBasemap: 4,
    featureInfoLayers:[],
    currentFeatureInfoLayer: 1,
    loadingFeatureInfo: false,
    showPopup: false
}

const changeBackground = (state,action) => {
    return updateObject(state, {selectedBasemap:action.index});
}

const getFeatureInfoStarted = (state) => {
    return updateObject(state, {loadingFeatureInfo:true, showPopup:true});
}

const getFeatureInfoSuccess = (state,action) => {
    let featureInfoLayers = [];

    action.layersData.forEach((layerData, index) => {
        if (layerData.data.features && layerData.data.features.length > 0){
            featureInfoLayers.push({layer:action.layers[index].layerName, layerData:layerData, layerLabel:action.layers[index].layerLabel, layerProperties:action.layers[index].layerProperties})
        }
    });

    return updateObject(state, {loadingFeatureInfo:false, featureInfoLayers:featureInfoLayers});
}

const getFeatureStart = (state) => {
    return updateObject(state, {loadingFeatureInfo:true});
}

const getFeatureSuccess = (state,action) => {
    let featureInfoLayers = [];

    action.layersData.forEach(layerData => {
        featureInfoLayers.push({layer:layerData.layerName, layerData:layerData.data});
    });

    return updateObject(state, {featureInfoLayers:featureInfoLayers, loadingFeatureInfo:false, showPopup:true});
}

const changeFeaturePanel = (state,action) => {
    let currentFeatureInfoLayer = state.currentFeatureInfoLayer

    if (action.action === "add"){
        currentFeatureInfoLayer = currentFeatureInfoLayer + 1;
    } else if (action.action === "subtract") {
        currentFeatureInfoLayer = currentFeatureInfoLayer - 1;
    } else if (action.action === "reset") {
        currentFeatureInfoLayer = 1;
    }

    return updateObject(state, {currentFeatureInfoLayer:currentFeatureInfoLayer});
}

const closePopup = (state) => {
    return updateObject(state, {loadingFeatureInfo:false, showPopup:false});
}


const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.CHANGE_BACKGROUND: return changeBackground(state, action);
        case actionTypes.GET_FEATURE_INFO_STARTED: return getFeatureInfoStarted(state);
        case actionTypes.GET_FEATURE_INFO_SUCCESS: return getFeatureInfoSuccess(state,action);
        case actionTypes.GET_FEATURE_START: return getFeatureStart(state);
        case actionTypes.GET_FEATURE_SUCCESS: return getFeatureSuccess(state, action);
        case actionTypes.CHANGE_FEATURE_PANEL: return changeFeaturePanel(state,action);
        case actionTypes.CLOSE_POPUP: return closePopup(state);
        default: return state;
    }
};

export default reducer;